export default "__VITE_ASSET__Bwaqi$nG__"